import React, { useEffect, useState } from "react";
import useForm from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { translator } from "../utils/i18n";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import {
  FormControlLabel,
  Radio,
  RadioGroup,
  TextField
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import PhoneInput from "react-phone-number-input";
import { PHONE_ALLOWED_COUNTRIES } from "../utils/constants";
import { parsePhoneNumberFromString } from "libphonenumber-js";
import metadataMobile from "libphonenumber-js/metadata.mobile.json";
import { Trans } from "@lingui/macro";
import { KeyboardDatePicker } from "@material-ui/pickers";
import Select from "@material-ui/core/Select";
import Switch from "@material-ui/core/Switch";
import InputLabel from "@material-ui/core/InputLabel";
import { savePatientFromAdmin } from "../utils/fetcher";

export default function Patient() {
  const user = useSelector(state => state.detailPatient) || {};
  const { handleSubmit, register, errors, setValue } = useForm();
  const [selectedDate, setSelectedDate] = useState(null);
  const initialFocusedDate = new Date();
  initialFocusedDate.setFullYear(initialFocusedDate.getFullYear() - 18);
  const dispatch = useDispatch();
  const today = new Date();
  const minDate = new Date();
  minDate.setFullYear(today.getFullYear() - 150);

  useEffect(() => {
    if (Object.keys(user).length) {
      register({
        name: "civilite"
      });
      register({
        name: "idaff_telport",
        required: translator()._("W_CE_CHAMP_EST_OBLIGATOIRE")
      });
      register({
        name: "idaff_telfixe",
        required: translator()._("W_CE_CHAMP_EST_OBLIGATOIRE")
      });
      register({
        name: "indicatif_mobile"
      });
      register({
        name: "indicatif_fixe"
      });
      register({
        name: "id_datenaissance"
      });
      register({
        name: "idinterpro"
      });
    }
  }, [user]);

  const onChangeRadio = e => {
    setValue(e.target.name, e.target.value);
  };

  const handleChangeCellPhone = tel => {
    const phoneNumber = parsePhoneNumberFromString(tel || "");
    const telIsValid = phoneNumber ? phoneNumber.isValid() : false;
    if (telIsValid) {
      setValue(
        "idaff_telport",
        phoneNumber.format("NATIONAL").replace(/ /g, "")
      );
      setValue("indicatif_mobile", phoneNumber.countryCallingCode);
    }
  };

  const handleChangePhone = tel => {
    const phoneNumber = parsePhoneNumberFromString(tel || "");
    const telIsValid = phoneNumber ? phoneNumber.isValid() : false;
    if (telIsValid) {
      setValue(
        "idaff_telfixe",
        phoneNumber.format("NATIONAL").replace(/ /g, "")
      );
      setValue("indicatif_fixe", phoneNumber.countryCallingCode);
    }
  };

  const handleChangeDob = date => {
    const formatedDate = date
      ? date.day + "/" + date.month + "/" + date.year
      : "";
    setValue("id_datenaissance", formatedDate);
    setSelectedDate(date);
  };

  const handleChangeStatus = event => {
    setValue("idinterpro", event.target.checked ? 1 : 0);
  };

  const onSubmit = values => {
    dispatch(savePatientFromAdmin(values));
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="my-profile-form">
      <div className="item-form">
        <FormControl className="inline-radio">
          <FormLabel className="mr-20">
            {translator()._("W_STEP4_AJOUTER_UNE_PERSONE_CIVILITE")}
          </FormLabel>
          <RadioGroup name="civilite" onChange={onChangeRadio} row>
            <FormControlLabel
              value="1"
              control={<Radio color="primary" />}
              label={translator()._("W_STEP4_CIVILITE_M")}
            />
            <FormControlLabel
              value="2"
              control={<Radio color="primary" />}
              label={translator()._("W_STEP4_CIVILITE_MME")}
            />
          </RadioGroup>
        </FormControl>
      </div>
      <div className="item-form">
        <div className="item">
          <TextField
            label={translator()._("W_STEP4_FORMULAIRE_NOM")}
            variant="outlined"
            inputRef={register}
            name="idaff_nom"
          />
        </div>
        <div className="item">
          <TextField
            label={translator()._("W_STEP4_FORMULAIRE_PRENOM")}
            variant="outlined"
            inputRef={register}
            name="idaff_prenon"
          />
        </div>
        <div className="item">
          <TextField
            label={translator()._("W_STEP4_FORMULAIRE_EMAIL")}
            variant="outlined"
            inputRef={register({
              required: `${translator()._("W_CE_CHAMP_EST_OBLIGATOIRE")}`,
              pattern: {
                value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                message: `${translator()._("W_ADRESSE_E_MAIL_NON_VALIDE")}`
              }
            })}
            name="idaff_email"
          />
          {errors.idaff_email && errors.idaff_email.message}
        </div>
      </div>
      <div className="item-form">
        <div className="item">
          <PhoneInput
            className="intl-tel-input"
            countries={PHONE_ALLOWED_COUNTRIES}
            country={user.indicatif_national_abreviation}
            defaultCountry={user.indicatif_national_fixe}
            international={false}
            onChange={phone => handleChangeCellPhone(phone)}
            limitMaxLength={true}
            metadata={metadataMobile}
            placeholder={`${translator()._(
              "FORMULAIRE_TELEPHONE"
            )} : 06 62 23 23 23`}
          />
          {errors.idaff_telport && errors.idaff_telport.message}
        </div>
        <div className="item">
          <PhoneInput
            className="intl-tel-input"
            countries={PHONE_ALLOWED_COUNTRIES}
            country={user.indicatif_national_fixe}
            defaultCountry={user.indicatif_national_fixe}
            international={false}
            onChange={phone => handleChangePhone(phone)}
            limitMaxLength={true}
            metadata={metadataMobile}
            placeholder={`${translator()._("W_STEP4_FORMULAIRE_MOBILE_FIXE")}`}
          />
          {errors.idaff_telfixe && errors.idaff_telfixe.message}
        </div>
      </div>
      <div className="item-form item-address">
        <div className="item">
          <TextField
            name="adresse_mod_up"
            id="outlined-multiline-static"
            label={translator()._("W_ADRESSE")}
            multiline
            variant="outlined"
            inputRef={register}
            fullWidth={true}
          />
        </div>
        <div className="item">
          <TextField
            name="code_postal_mod_up"
            label={translator()._("W_CODE_POSTAL")}
            variant="outlined"
            inputRef={register}
          />
        </div>
        <div className="item">
          <TextField
            name="ville_mod_up"
            label={translator()._("W_VILLE")}
            variant="outlined"
            inputRef={register}
          />
        </div>
      </div>
      <div className="item-form">
        <div className="item">
          <KeyboardDatePicker
            className="field-custom-date"
            value={selectedDate}
            placeholder="jj/mm/aaaa"
            onChange={handleChangeDob}
            minDate={minDate}
            maxDate={today}
            format="dd/MM/yyyy"
            label={translator()._("FORMULAIRE_DATE_DE_NAISSANCE")}
            inputVariant="outlined"
            name="id_datenaissance"
            disableFuture
            openTo="year"
            views={["year", "month", "date"]}
            okLabel={<Trans id="W_STEP_POPUP_BOUTON_OK" />}
            cancelLabel={<Trans id="W_ANNULER" />}
            initialFocusedDate={initialFocusedDate}
            invalidDateMessage={translator()._("W_DATE_INVALID")}
            minDateMessage={translator()._("W_MIN_DATE_ALERT")}
          />
        </div>
        <div className="item">
          <TextField
            name="num_secu_mod_up"
            label={translator()._("W_SECURITE_SOCIAL")}
            variant="outlined"
            inputRef={register}
          />
        </div>
        <div className="item">
          <FormControl variant="outlined">
            <InputLabel htmlFor="outlined-age-native-simple">
              Assurance maladie
            </InputLabel>
            <Select
              inputRef={register}
              native
              label="Assurance maladie"
              inputProps={{
                name: "selectassurance",
                id: "outlined-age-native-simple"
              }}
            >
              <option>Choisissez vote assurance</option>
              <option value="1">ACS</option>
              <option value="2">AME</option>
              <option value="3">CMU</option>
              <option value="4">Sécurité Sociale</option>
            </Select>
          </FormControl>
        </div>
      </div>
      <div className="item-form">
        <div className="item">
          <TextField
            name="medecintrait"
            label={translator()._("W_MEDECIN_TRAITANT")}
            variant="outlined"
            inputRef={register}
          />
        </div>
        <div className="item">
          <TextField
            name="ville_medecin_mod_up"
            label={translator()._("W_VILLE_MEDECIN_TRAITANT")}
            variant="outlined"
            inputRef={register}
          />
        </div>
        <div className="item">
          <TextField
            name="profession_mod_up"
            label={translator()._("W_PROFESSION")}
            variant="outlined"
            inputRef={register}
          />
        </div>
      </div>
      <div className="item-form">
        <TextField
          name="remarque"
          id="outlined-multiline-static"
          label="Information du rendez-vous"
          multiline
          rows="2"
          variant="outlined"
          inputRef={register}
          fullWidth={true}
        />
      </div>
      <div className="item-form">
        <FormControlLabel
          control={<Switch onChange={handleChangeStatus} name="idinterpro" />}
          label="Définir un RDV récurrent"
          labelPlacement="start"
        />
      </div>

      <Button size="small" type="submit" variant="contained" color="secondary">
        {translator()._("W_VALIDER")}
        <i className="material-icons">done</i>
      </Button>
    </form>
  );
}
